export default "__VITE_ASSET__acd3e05b__"